import React, { useEffect, useState } from 'react';
import { Drawer, Icon, ModalBox, useMediaQueryContext } from '@fourthwall/components';
import { CloseIcon } from '@fourthwall/icons';
import TagManager from 'react-gtm-module';
import { useLaunchStrategyModal } from './hooks/useLaunchStrategyModal';
import * as S from './styled';
import { ContentHeader } from './components/ContentHeader';
import { Navigation } from './components/Navigation';
import { Guide } from './components/Guide/Guide';
export const LaunchStrategyModal = ({ data, initialCategoryIndex, initialGuideIndex, totalGuides, onClose, onProgressChange, }) => {
    const [headGuideLoaded, setHeadGuideLoaded] = useState(false);
    const media = useMediaQueryContext();
    const { activeCategoryIndex, activeGuideIndex, absoluteActiveGuideIndex, drawer, guide, onNext, onPrevious, onChange, } = useLaunchStrategyModal({
        categories: data.categories,
        initialCategoryIndex,
        initialGuideIndex,
        onProgressChange,
    });
    const allGuidesUrls = data.categories.flatMap((category) => category.guides.map((guide) => guide.url));
    useEffect(() => {
        TagManager.dataLayer({
            dataLayer: { event: 'launch_strategy_modal' },
        });
    }, []);
    const handleClose = () => onClose(absoluteActiveGuideIndex);
    const renderDrawer = () => {
        if (media.tablet)
            return;
        return (React.createElement(Drawer, null, drawer.drawerActive && (React.createElement(Drawer.Body, { position: "left", width: "80%", overlay: React.createElement(Drawer.Overlay, { onClick: drawer.drawerClose }) },
            React.createElement(Drawer.Content, null,
                React.createElement(S.Sidebar, null,
                    React.createElement(Navigation, { categories: data.categories, activeGuideIndex: activeGuideIndex, activeCategoryIndex: activeCategoryIndex, onChange: onChange, onGuideSelect: drawer.drawerClose })))))));
    };
    return (React.createElement(ModalBox, { fullWidth: true, size: media.tablet ? undefined : 'fullScreen', withoutPadding: true, withoutCloseButton: true, maxWidth: 1060, onClose: handleClose },
        React.createElement(S.Container, null,
            media.tablet && (React.createElement(S.Sidebar, null,
                React.createElement(S.TextualContent, null,
                    React.createElement(S.Title, null, data.title),
                    React.createElement(S.Description, null, data.description)),
                React.createElement(Navigation, { categories: data.categories, activeGuideIndex: activeGuideIndex, activeCategoryIndex: activeCategoryIndex, onChange: onChange }))),
            React.createElement(S.Content, null,
                !media.tablet && (React.createElement(S.ModalHeader, null,
                    React.createElement(S.TextualContent, null,
                        React.createElement(S.Title, null, data.title),
                        React.createElement(S.Description, null, data.description)),
                    React.createElement(S.CloseButton, { onClick: handleClose },
                        React.createElement(Icon, { component: CloseIcon, height: 16 })))),
                React.createElement(ContentHeader, { title: guide.title, progressValue: absoluteActiveGuideIndex + 1, maxProgressValue: totalGuides, onOpenDrawer: drawer.drawerOpen, onPrevious: onPrevious, onNext: onNext, onClose: handleClose }),
                React.createElement(S.GuidesWrapper, null, allGuidesUrls.map((url, index) => {
                    const active = url === guide.url;
                    const shouldLoad = active ||
                        headGuideLoaded ||
                        index === absoluteActiveGuideIndex - 1 ||
                        index === absoluteActiveGuideIndex + 1;
                    return (React.createElement(Guide, { key: index, active: active, shouldLoad: shouldLoad, url: url, onLoad: active ? () => setHeadGuideLoaded(true) : undefined }));
                })))),
        renderDrawer()));
};
